import type * as React from 'react';
import type { ImageBackgroundCallToActionContext } from '../ImageBackgroundCallToActionContext';
import { assertNever } from '~/Partials/Utils/typeUtils';

export const getHTMLHeading = (
    context: ImageBackgroundCallToActionContext
): keyof Pick<React.ReactHTML, 'h1' | 'h2'> => {
    switch (context) {
        case 'page':
            return 'h1';
        case 'section':
            return 'h2';
        default:
            return assertNever(context);
    }
};
